export default "__VITE_ASSET__DbxZh2EJ__"